import { useState, useCallback } from "react";
import privateAxios from "../../utils/axiosPrivate";
import {
  getReckonSyncInvoiceURL,
  getmyobsyncinvoicesUrl,
  getQuickbooksSyncInvoiceURL
} from "../../utils/constants/apiEndPoints";
import {
  RECKON,
  MYOB,
  QUICKBOOKS,
  XERO
} from "../../utils/constants/appConstants";

export const useInvoiceSync = ({
  connectedSoftName,
  handleXeroSyncInvoice,
  onSuccess
}) => {
  const [loading, setLoading] = useState(false);

  const syncInvoices = useCallback(async () => {
    try {
      setLoading(true);
      let res;
      switch (connectedSoftName) {
        case RECKON:
          res = await privateAxios.post(getReckonSyncInvoiceURL);
          break;
        case MYOB:
          res = await privateAxios.post(getmyobsyncinvoicesUrl);
          break;
        case QUICKBOOKS:
          res = await privateAxios.post(getQuickbooksSyncInvoiceURL);
          break;
        case XERO:
          return handleXeroSyncInvoice();
        default:
          return;
      }

      onSuccess?.(res);
    } finally {
      setLoading(false);
    }
  }, [connectedSoftName, handleXeroSyncInvoice, onSuccess]);

  return { syncInvoices, loading };
};
